import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: {
      // 是否需要校验登录
      auth: false,
      keepAlive: false
    }
  },
  {
    path: '/v2',
    name: 'index2',
    component: () => import('@/views/v2/index.vue'),
    meta: {
      // 是否需要校验登录
      auth: false,
      keepAlive: false
    }
  }
]

export default routes
